import { render, staticRenderFns } from "./ServiceDetailList.vue?vue&type=template&id=5133c378"
import script from "./ServiceDetailList.vue?vue&type=script&lang=js"
export * from "./ServiceDetailList.vue?vue&type=script&lang=js"
import style0 from "./ServiceDetailList.vue?vue&type=style&index=0&id=5133c378&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports